// extracted by mini-css-extract-plugin
export default {"containermobile":"Projects_containermobile__FCY1Z","container":"Projects_container__ymVch","row":"Projects_row__szuHU"};